import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { PostReisekostenabrechnungStatusCommandService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [PostReisekostenabrechnungStatusCommandService],
  exports: []
})
export class PostReisekostenabrechnungStatusCommandServiceModule { }
